import React from "react";
import { Link } from "react-router-dom";
import Home from './Home'
import { Helmet } from 'react-helmet'
import Sidebar from './SideBar'
import { useParams } from "react-router";
import Myurl from '../Components/Myurl'
// import { useLocation } from "react-router";
import { useState } from "react";
import Loader from "./Loader";
import MyUrlmage from "./MyUrlmage";

function Search() {
  // const mylocate = useLocation()
  const { search } = useParams()
  const [homeshow, setHomeshow] = useState(<Loader />)
  const Homeshows = async () => {
    try {
      const res = await fetch(`${Myurl}/courses.json`, {
        method: "GET"
      })
      const Data = await res.json()
      let getSearch;
      let flags;
      if (search) {
        flags = 1;
        getSearch = search
      }
      else {
        flags = 0;
        getSearch = ""
      }

      function ncard(val) {
        if (flags === 1) {
          if (
            val.Name.toLowerCase().replace(/ /g, "").indexOf(getSearch.toLowerCase().replace(/ /g, "")) > -1 ||
            val.Name.toLowerCase().replace(/s/g, "").indexOf(getSearch.toLowerCase().replace(/s/g, "")) > -1 ||
            val.Categories.toLowerCase().replace(/s/g, "").indexOf(getSearch.toLowerCase().replace(/s/g, "")) > -1 ||
            val.Categories.toLowerCase().replace(/ /g, "").indexOf(getSearch.toLowerCase().replace(/ /g, "")) > -1 ||
            val.desc.toLowerCase().replace(/s/g, "").indexOf(getSearch.toLowerCase().replace(/s/g, "")) > -1 ||
            val.desc.toLowerCase().replace(/ /g, "").indexOf(getSearch.toLowerCase().replace(/ /g, "")) > -1 ||
            val.content.toLowerCase().replace(/ /g, "").indexOf(getSearch.toLowerCase().replace(/ /g, "")) > -1 ||
            val.content.toLowerCase().replace(/\/n/g, "").indexOf(getSearch.toLowerCase().replace(/ /g, "")) > -1
          ) {
            return (
              <>
                <div style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                  <h2>
                    <Link to={val.To} className="text-dark">
                      {val.Name}
                    </Link>
                  </h2>
                  <p>{val.desc}</p>
                  <Link to={val.To} className="btn btn-outline-danger">
                    Start Learning
                  </Link>
                  <hr />
                </div>
              </>
            );
          }
        }
      }

      function hello23() {
        if (flags === 1) {
          let Flag;
          for (let index = 0; index < Data.length; index++) {
            if (
              Data[index].Name.toLowerCase().replace(/ /g, "").indexOf(search.toLowerCase().replace(/ /g, "")) > -1 ||
              Data[index].Name.toLowerCase().replace(/s/g, "").indexOf(search.toLowerCase().replace(/s/g, "")) > -1 ||
              Data[index].Categories.toLowerCase().replace(/s/g, "").indexOf(search.toLowerCase().replace(/s/g, "")) > -1 ||
              Data[index].Categories.toLowerCase().replace(/ /g, "").indexOf(search.toLowerCase().replace(/ /g, "")) > -1 ||
              Data[index].desc.toLowerCase().replace(/s/g, "").indexOf(search.toLowerCase().replace(/s/g, "")) > -1 ||
              Data[index].desc.toLowerCase().replace(/ /g, "").indexOf(search.toLowerCase().replace(/ /g, "")) > -1 ||
              Data[index].content.toLowerCase().replace(/ /g, "").indexOf(getSearch.toLowerCase().replace(/ /g, "")) > -1 ||
              Data[index].content.toLowerCase().replace(/\/n/g, "").indexOf(getSearch.toLowerCase().replace(/ /g, "")) > -1
            ) {
              Flag = 1;
            } else {
            }
          }
          if (Flag === 1) {
          } else {
            return (
              <>
                <div className="list-group folder-group">
                  <div className="row no_ls">
                    <div className="noResultFound">
                      <img src={`${MyUrlmage}/media/images/noResultsFound.jpg`} className="noResultFound img-fluid" alt="NoResults" /></div>
                    <h2 className="mt-1" style={{ fontSize: '25px', display: 'block', width: '100%', textAlign: "center" }}>Sorry we have 0 search results for '<b>{search}</b>'.<br /> Try again with another specific search term
                    </h2>
                  </div>
                </div>
              </>
            );
          }
        }
      }
      if (getSearch === "") {
        setHomeshow(<><Sidebar /><Home Alert="Yes" /></>)
      }
      else {
        setHomeshow(<div className="cat">
          <Helmet>
            <title>{'Search Results with '}{search}</title>
          </Helmet>
          <div className="mb-5">
            <div className="list-group mt-3">
              <button className="btn btn-success d-block p-2">
                Search Results
              </button>
              <div className="card card-body" style={{ minHeight: "350px" }}>
                <div className="main-container container-fluid">
                  <h1>Search Results with {search}</h1>
                  <hr />
                  <div>
                    {Data.map(ncard)}
                    {hello23()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>)
      }
    }
    catch {

    }
  }
  // useEffect(() => {
    Homeshows()
  // }, [mylocate.pathname])
  return (
    <>
      <div>
        {/* {Homeshow()} */}
        {homeshow}
      </div>
    </>
  );
}

export default Search;
